

























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import MainTabbar from "../general/MainTabbar.vue";

import RentalOverview from "./RentalOverview.vue";
import RentalBookings from "./RentalBookings.vue";
import RentalProducts from "./RentalProducts.vue";
import RentalAccounts from "./RentalAccounts.vue";
import RentalPayments from "./RentalPayments.vue";

import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";
import UserJson from "../../shared/UserJson";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import { checkPermission } from "../../shared/UserPermission";
import { UserPermissionType } from "../../shared/UserPermissionType";

export default Vue.extend({
  name: "Rental",
  components: {
    MainTabbar,
    RentalOverview,
    RentalBookings,
    RentalProducts,
    RentalAccounts,
    RentalPayments,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      currentMainTabbarTab: "",
      checkModuleIsActivated: checkModuleIsActivated,
      checkPermission: checkPermission,
    };
  },
  created() {},
  methods: {
    changeMainTabbarTab: function (tab: string) {
      this.currentMainTabbarTab = tab;
    },
  },
  computed: {
    mainTabbarItems(): ModulesJson[] {
      let vue = this;

      return [
        {
          title: "Übersicht",
          linkedComponent: "RentalOverview",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleRental),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleRental),
        },
        {
          title: "Buchungen",
          linkedComponent: "RentalBookings",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleRental),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleRental),
        },
        {
          title: "Produkte",
          linkedComponent: "RentalProducts",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleRental),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleRental),
        },
        {
          title: "Accounts",
          linkedComponent: "RentalAccounts",
          permissionRank: 2,
          userPermission: null,
          isDisabled: true,
          isDisplayed: false,
        },
        {
          title: "Zahlungen",
          linkedComponent: "RentalPayments",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
        },
      ] as ModulesJson[];
    },
  },
});
